
























































































































































































































































































































































































































import { Component, Prop, PropSync, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  DataTable,
  defaultSortColumn,
  SortColumn
} from '@/components/molecules/DataTable'
import {
  defaultSystemCode,
  SystemCode,
  systemCodeApi,
  SystemCodeWithKey
} from '@/api'
import { orderBy } from 'lodash'
import {
  BookMaxlength,
  MarkMaxlength,
  NdcMask,
  NdcMaxlength,
  SubMaxlength
} from '@/types'
import { InputCodeTrader } from '@/components/molecules/InputCodeTrader'
import { InputCode } from '@/components/molecules/InputCode'
import { CODE_KEY } from '@/config'
import { InputCodeDonor } from '@/components/molecules/InputCodeDonor'
import { systemParameterStore } from '@/utils/store-accessor'

export interface AutoOrderTableItemInput {
  mark: {
    input: string
  }
  ndc: {
    input: string
  }
  book: {
    input: string
  }
  sub: {
    input: string
  }
}

export const AutoOrderTableItemInput = (): AutoOrderTableItemInput => ({
  mark: {
    input: ''
  },
  ndc: {
    input: ''
  },
  book: {
    input: ''
  },
  sub: {
    input: ''
  }
})

export interface AutoOrderTableItemRow {
  isSelected: boolean
  orderAutoId: number | null
  orderBranchCode: SystemCode
  orderNumber: {
    input: string
    errorMessage: string
  }
  traderCode: {
    input: string
    display: string
    errorMessage: string
  }
  acceptType: {
    input: string
    display: string
    errorMessage: string
  }
  buyDepartmentCode: {
    input: string
    display: string
    errorMessage: string
  }
  donatedNumber: {
    input: string
    errorMessage: string
  }
  donorCode: {
    input: string
    display: string
    errorMessage: string
  }
  budgetYear: {
    input: string
    errorMessage: string
  }
  budgetBranchCode: {
    input: string
    display: string
    errorMessage: string
  }
  budgetDepartmentCode: {
    input: string
    display: string
    errorMessage: string
  }
  budgetItem: {
    input: string
    display: string
    errorMessage: string
  }
  equipType: {
    input: string
    display: string
    errorMessage: string
  }
  collectionType: {
    input: string
    display: string
    errorMessage: string
  }
  shelfType: {
    input: string
    display: string
    errorMessage: string
  }
  handlingType: {
    input: string
    display: string
    errorMessage: string
  }
  storeType: {
    input: string
    display: string
    errorMessage: string
  }
  storingLimitCode: {
    input: string
    display: string
    errorMessage: string
  }
  mark: {
    input: string
    errorMessage: string
  }
  ndc: {
    input: string
    errorMessage: string
  }
  book: {
    input: string
    errorMessage: string
  }
  sub: {
    input: string
    errorMessage: string
  }
  revision: number | null
}

export const defaultAutoOrderTableItemRow = (): AutoOrderTableItemRow => ({
  isSelected: false,
  orderAutoId: null,
  orderBranchCode: defaultSystemCode(),
  orderNumber: {
    input: '',
    errorMessage: ''
  },
  traderCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  acceptType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  buyDepartmentCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  donatedNumber: {
    input: '',
    errorMessage: ''
  },
  donorCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  budgetYear: {
    input: '',
    errorMessage: ''
  },
  budgetBranchCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  budgetDepartmentCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  budgetItem: {
    input: '',
    display: '',
    errorMessage: ''
  },
  equipType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  collectionType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  shelfType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  handlingType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  storeType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  storingLimitCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  mark: {
    input: '',
    errorMessage: ''
  },
  ndc: {
    input: '',
    errorMessage: ''
  },
  book: {
    input: '',
    errorMessage: ''
  },
  sub: {
    input: '',
    errorMessage: ''
  },
  revision: null
})

export interface AutoOrderTableItem {
  input: AutoOrderTableItemInput
  rows: AutoOrderTableItemRow[]
  sortColumn: SortColumn
  sortedRows: () => AutoOrderTableItemRow[]
  selectedRow: () => AutoOrderTableItemRow
  select: (index: number) => void
}

export const defaultAutoOrderTableItem = (): AutoOrderTableItem => ({
  input: AutoOrderTableItemInput(),
  rows: [],
  sortColumn: defaultSortColumn(),
  sortedRows() {
    if (this.sortColumn.name) {
      return orderBy<AutoOrderTableItemRow>(
        this.rows,
        (item: AutoOrderTableItemRow) => {
          const propertyValue: any =
            // eslint-disable-next-line standard/computed-property-even-spacing
            item[this.sortColumn.name as keyof AutoOrderTableItemRow]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (this.sortColumn.name === 'orderBranchCode') {
            return propertyValue.code
          }

          if (this.sortColumn.name === 'callNo') {
            return (
              item.mark.input +
              item.ndc.input +
              item.book.input +
              item.sub.input
            )
          }

          if (type === 'object') {
            return propertyValue?.display ?? propertyValue.input
          }

          return propertyValue
        },
        this.sortColumn.order as 'asc' | 'desc'[]
      )
    }

    return this.rows
  },
  selectedRow() {
    return (
      this.rows.find(row => row.isSelected) ?? defaultAutoOrderTableItemRow()
    )
  },
  select(selectIndex: number) {
    this.sortedRows().forEach(
      (row: AutoOrderTableItemRow, index: number) =>
        (row.isSelected = index === selectIndex)
    )
  }
})

@Component({
  components: { InputCodeDonor, InputCode, InputCodeTrader, DataTable }
})
export default class AutoOrderTable extends ComponentVue {
  @PropSync('tableItem', {
    type: Object,
    required: true
  })
  item!: AutoOrderTableItem

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  isEdit!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  isSelect!: boolean

  get markMaxlength(): string {
    return MarkMaxlength
  }

  get ndcMask(): string {
    return NdcMask
  }

  get ndcMaxlength(): string {
    return NdcMaxlength
  }

  get bookMaxlength(): string {
    return BookMaxlength
  }

  get subMaxlength(): string {
    return SubMaxlength
  }

  get acceptTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.ACCEPT_TYPE.KEY)
  }

  get departmentSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.DEPARTMENT.KEY)
  }

  get libraryBranchSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.LIBRARY_BRANCH.KEY)
  }

  get expenseSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.EXPENSE.KEY)
  }

  get equipmentConsumableTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(
      CODE_KEY.EQUIPMENT_CONSUMABLE_TYPE.KEY
    )
  }

  get collectionTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.COLLECTION_TYPE.KEY)
  }

  get shelfTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.SHELF_TYPE.KEY)
  }

  get handlingTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.HANDLING_TYPE.KEY)
  }

  get saveSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.SAVE.KEY)
  }

  get saveDeadLineSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.SAVE_DEADLINE.KEY)
  }

  get concatenationNumber(): string {
    return systemParameterStore.callNumberConcatenationNumber
  }

  get cols(): Col[] {
    const cols: Col[] = [
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'orderBranchCode',
            headerText: '館',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'orderBranchCode'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'orderNumber',
            headerText: '発注冊数',
            align: 'right',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'orderNumber'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'traderCode',
            headerText: '購入業者',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'traderCode'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'acceptType',
            headerText: '受入区分',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'acceptType'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'buyDepartmentCode',
            headerText: '購入部署',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'buyDepartmentCode'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'donatedNumber',
            headerText: '寄贈冊数',
            align: 'right',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'donatedNumber'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'donorCode',
            headerText: '寄贈者',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'donorCode'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'budgetYear',
            headerText: '予算年度',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'budgetYear'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'budgetBranchCode',
            headerText: '予算館',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'budgetBranchCode'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'budgetDepartmentCode',
            headerText: '予算部署',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'budgetDepartmentCode'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'budgetItem',
            headerText: '予算費目',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'budgetItem'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'equipType',
            headerText: '備消',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'equipType'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'collectionType',
            headerText: '資料区分',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'collectionType'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'shelfType',
            headerText: '配架区分',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'shelfType'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'handlingType',
            headerText: '取扱区分',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'handlingType'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'storeType',
            headerText: '保存区分',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'storeType'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'storingLimitCode',
            headerText: '保存期限',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'storingLimitCode'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'callNo',
            headerText: '請求記号',
            sortable: false,
            sortOrder:
              this.item.sortColumn.name === 'callNo'
                ? this.item.sortColumn.order
                : ''
          }
        ]
      }
    ]

    if (this.isSelect) {
      cols.unshift({
        width: 26,
        items: [
          {
            name: 'radio',
            align: 'center'
          }
        ]
      })
    }

    if (!this.isEdit) {
      cols.forEach(col => col.items.forEach(item => (item.sortable = true)))
    }

    return cols
  }

  onSortRows(sortColumn: SortColumn): void {
    this.item.sortColumn = sortColumn
  }

  updateAllCallNo(): void {
    this.item.rows.forEach(value => {
      value.mark.input = this.item.input.mark.input
      value.ndc.input = this.item.input.ndc.input
      value.book.input = this.item.input.book.input
      value.sub.input = this.item.input.sub.input
    })
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  callNumber(mark: string, ndc: string, book: string, sub: string): string {
    const callNumberAry = [mark, ndc, book, sub]

    return callNumberAry.some(part => part !== '')
      ? callNumberAry.join(this.concatenationNumber)
      : '編集'
  }

  @Emit('link')
  onClickLink(index: number): number {
    return index
  }
}
